import React, { useEffect } from "react";
import { CloseButton, Toast, ToastContainer } from "react-bootstrap";
import { EnvelopePaper } from "react-bootstrap-icons";

interface IVerificationSentToastProps {
  isShow: boolean;
  handleClose: () => void;
  message: string;
}

export default function VerificationSentToast({
  isShow,
  handleClose,
  message,
}: IVerificationSentToastProps) {
  useEffect(() => {
    if (isShow) {
      const timer = setTimeout(() => {
        handleClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [handleClose, isShow]);

  return (
    <ToastContainer
      position="bottom-center"
      className="px-2 px-md-5 py-5 position-fixed"
    >
      <Toast
        show={isShow}
        bg="dark"
        className="rounded-3"
        style={{ width: "385px" }}
      >
        <Toast.Body className="text-white d-flex align-items-center justify-content-between gap-3 py-2 px-md-3">
          <div className="d-flex align-items-center gap-2">
            <EnvelopePaper className="text-white flex-shrink-0" size={14} />
            <span className="text-white fs-7">{message}</span>
          </div>
          <CloseButton variant="white" className="fs-6" onClick={handleClose} />
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
}
